var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"host page"},[_c('DataTable',{attrs:{"title":"Международный классификатор болезней","permissions":['read'],"service":_vm.service,"fields":_vm.tableFileds,"pageSize":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }